import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { connect } from 'react-redux';
import { patchLink } from 'redux/links/actions';

import { Checkbox } from 'semantic-ui-react';
import { Link } from 'react-router-dom';

import ProLabel from 'components/common/ProLabel/index.js';
import ButtonSwitcher from 'components/elements/buttons/ButtonSwitcher';
import CommonPopup from 'components/common/CommonPopup';

import './CommonLinkVideoOptions.css';

function CommonLinkVideoOptions(props) {
  const { me, linkItem, patchLink } = props;
  const { t } = useTranslation();
  const [isEmbed, setIsEmbed] = useState(linkItem.is_embed);
  const [isAutoplay, setIsAutoplay] = useState(linkItem.is_autoplay);
  const [isMute, setIsMute] = useState(linkItem.is_mute);

  useEffect(() => {
    if (['youtube', 'facebook'].includes(linkItem.video_service)) {
      setIsMute(isAutoplay);
      const form = new FormData();
      form.append('is_autoplay', isAutoplay);
      form.append('is_mute', isAutoplay);
      patchLink(linkItem.id, form);
    }
  }, [isAutoplay]);

  const buttonSwitcherList = [
    {
      buttonName: t("Link"),
      executeFunc: () => {
        setIsEmbed(false);
        patchLink(linkItem.id, { 'is_embed': false });
      },
      checked: !isEmbed,
    },
    {
      buttonName: t("Embed video"),
      executeFunc: () => {
        setIsEmbed(true);
        patchLink(linkItem.id, { 'is_embed': true });
      },
      checked: isEmbed,
    },
  ];

  const isPro = me && me.subscription && me.subscription.ff_videolink;

  const renderCheckboxes = isPro && linkItem.video_service !== 'tiktok' && (
    <div className="checkboxes-wrapper">
      <div className="checkbox">
        <Checkbox
          label={t("Autoplay")}
          checked={isAutoplay}
          onChange={() => {
            setIsAutoplay(!isAutoplay);
            if (linkItem.video_service === 'vimeo') {
              patchLink(linkItem.id, { 'is_autoplay': !linkItem.is_autoplay });
            }
          }}
        />
      </div>

      <div className="checkbox">
        <Checkbox
          label={t("Mute video")}
          checked={isMute}
          onChange={() => {
            setIsMute(!isMute);
            if (linkItem.video_service === 'vimeo') {
              patchLink(linkItem.id, { 'is_mute': !linkItem.is_mute });
            }
          }}
          disabled={['youtube', 'facebook'].includes(linkItem.video_service)}
        />
      </div>
    </div>
  );

  const renderLockedText = !isPro && (
    <div className="locked-text">
      {t("You can change Autoplay and Mute video settings on the PRO plan.")}
      {t("Upgrade")} <Link to="/billing">{t("here")}</Link>
    </div>
  );

  const renderUnavailableText = isPro && linkItem.video_service === 'tiktok' && (
    <div className="locked-text">
      {t("Autoplay and mute features are not available for this video link")}
    </div>
  );

  return (
    <div className="common-link-video-options__component">
      {/* Video Options Selector */}
      <div className="selector video">
        <div className="title">
          <div className="text">{t("Video Options")}</div>
          <CommonPopup
            questionIcon
            type="info"
          >
            {t("Choose to embed this video on your Heylink.me or link off")}
          </CommonPopup>
        </div>
        <ButtonSwitcher
          buttonsList={buttonSwitcherList}
          buttonWidth={120}
        />
      </div>

      {/* Embed Options Selector */}
      {linkItem.is_embed &&
        <div className="selector embed">
          <div className="title">
            <div className="text">{t("Embed Options")}</div>
            <ProLabel />
          </div>
          {renderCheckboxes}
          {renderLockedText}
          {renderUnavailableText}
        </div>
      }
    </div>
  );
}

CommonLinkVideoOptions.propTypes = {
  patchLink: PropTypes.func.isRequired,
  linkItem: PropTypes.object.isRequired,
  me: PropTypes.object,
};

CommonLinkVideoOptions.defaultProps = {
  me: null,
};

const mapStateToProps = state => (
  {
    me: state.usersReducer.me,
  }
);

export default connect(
  mapStateToProps,
  {
    patchLink,
  },
)(CommonLinkVideoOptions);
